export class RegisterRevealModel{
  revealSerialNumber:string;
  company:string;
  companyOfficial:string;
  country:string;
  communicationLanguage:string;
  profession:string;
  telephone:string;
  email:string;
  purchaseDate:string;
  invoiceNr:string;
  constructor(revealSerialNumber: string,
    company: string,
    companyOfficial: string,
    country: string,
    communicationLanguage:string,
    profession:string,
    telephone:string,
    email:string,
    purchaseDate:string,
    invoiceNr:string
  ) {
        this.revealSerialNumber = revealSerialNumber;
        this.company= company;
        this.companyOfficial= companyOfficial;
        this.country= country;
        this.communicationLanguage=communicationLanguage;
        this.profession= profession;
        this.telephone= telephone;
        this.email= email;
        this.purchaseDate=purchaseDate;
        this.invoiceNr=invoiceNr;
    }

}